
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/add-car",
      function () {
        return require("private-next-pages/dashboard/add-car.js");
      }
    ]);
  